import React from "react";
import styled from "styled-components";
import { ContainerComponents, ContentPage, Skeleton } from "@ficatranquilo/contabilidade.com-ui";

/**
 * Página do modelo Formulário do DS OneWork (formulário de contrato e de padrão):
 * aviso opcional, as FormBox em cartões sobre o fundo da página e as ações
 * (PageActions) no fim.
 *
 * Sem <form>: a lib renderiza botões sem `type` (o Button e o campo do DatePicker),
 * que dentro de um <form> enviariam a cada clique. O envio é o `$action` do botão
 * principal, como no ModalForm da lib.
 */

// Espaço embaixo das ações, antes do rodapé (as listas têm o da ContentBox)
const Page = styled(ContentPage)`
  padding-bottom: 30px;
`;

/** Bloco de largura total dentro da FormBox, que é inline-flex com quebra: sem isso, encolhe até o conteúdo. */
export const FullWidth = styled.div`
  width: 100%;
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export function FormPage({ notice, actions, children }) {
  return (
    <Page>
      <ContainerComponents>
        <Sections>
          {notice}
          {children}
        </Sections>
      </ContainerComponents>
      {actions}
    </Page>
  );
}

/**
 * Leva ao primeiro campo com erro, como o react-hook-form faz no ft-app-web: rola até
 * ele e foca. `fields`: ids na ordem da tela. No Select da lib o id fica no contêiner,
 * então o foco vai para o input dentro dele.
 */
export function focusFirstError(fields) {
  const el = fields.map((id) => document.getElementById(id)).find(Boolean);
  if (!el) return;
  el.scrollIntoView({ block: "center", behavior: "smooth" });
  const target = /^(INPUT|BUTTON|TEXTAREA)$/.test(el.tagName) ? el : el.querySelector("input, button");
  if (target) target.focus({ preventScroll: true });
}

/** Esqueleto enquanto o registro carrega: uma caixa por seção, com a altura dada. */
export function FormPageSkeleton({ sections }) {
  return (
    <ContentPage aria-busy="true">
      <ContainerComponents>
        <Sections>
          {sections.map((height, index) => (
            <Skeleton key={index} $height={height} />
          ))}
        </Sections>
      </ContainerComponents>
    </ContentPage>
  );
}
